var map = {
	"./brazil.png": 9132,
	"./cpu.jpeg": 6069,
	"./globe.png": 1067,
	"./logic.jpeg": 4032,
	"./logic2.jpeg": 4732,
	"./logo.png": 6949,
	"./logo.svg": 9574,
	"./motherboard.jpeg": 5848,
	"./pdf.png": 475,
	"./pdf/polettietal2019.pdf": 4431,
	"./perfil.jpg": 3579,
	"./photos/man.svg": 989,
	"./photos/woman.svg": 3200,
	"./pieces.jpeg": 9714,
	"./symbol.svg": 3871,
	"./unb1 copy.jpg": 552,
	"./unb1.jpg": 4788,
	"./united-states.png": 8583
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;